import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Grenada: Country = {
    identifier: "Grenada",
    name: "Grenada",
    countryCode: "GD",
    group: CountryGroup.CENTRAL_AMERICA,
    isUNMember: true,
    flag: "🇬🇩",
    svgPath: "m 301.69175,429.1834 -0.187,0.011 0.074,-0.105 0.016,-0.18 0.098,-0.219 0.153,-0.147 0.15,0.039 -0.056,0.482 z",
}
